import React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import SongDetailPage from "./SongDetailPage";
import songsAPI from "restApi/songsApi";
import LyricsThanks from "components/LyricsThanks";

export default () => {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [song, setSong] = React.useState({ loading: true });

  // Same pattern as the event page: return to whichever list linked
  // here, falling back to the catalog for a direct/shared link with no
  // in-app history at all.
  const goBack = () => {
    history.push((location.state && location.state.from) || "/catalog");
  };

  React.useEffect(() => {
    songsAPI.getSong(id).then(
      (res) => setSong({ loading: false, ...res.data }),
      // A bad/missing id, or (most often in practice) switching to a
      // team that doesn't have this song, would otherwise leave
      // `loading: true` forever, with nothing on screen but a spinner
      // and no explanation.
      () => setSong({ loading: false, notFound: true })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <SongDetailPage song={song} goBack={goBack} />
      <LyricsThanks />
    </>
  );
};
